var _rect, _path, _path2, _path3, _path4, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvailableCouriers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    fill: "#FDF2ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2718 28.0002C15.8987 28.0002 16.4999 27.7409 16.9432 27.2793C17.3864 26.8176 17.6355 26.1915 17.6355 25.5387C17.6355 24.8858 17.3864 24.2597 16.9432 23.7981C16.4999 23.3365 15.8987 23.0771 15.2718 23.0771C14.645 23.0771 14.0438 23.3365 13.6005 23.7981C13.1572 24.2597 12.9082 24.8858 12.9082 25.5387C12.9082 26.1915 13.1572 26.8176 13.6005 27.2793C14.0438 27.7409 14.645 28.0002 15.2718 28.0002V28.0002ZM27.09 28.0002C27.7169 28.0002 28.3181 27.7409 28.7614 27.2793C29.2046 26.8176 29.4537 26.1915 29.4537 25.5387C29.4537 24.8858 29.2046 24.2597 28.7614 23.7981C28.3181 23.3365 27.7169 23.0771 27.09 23.0771C26.4631 23.0771 25.8619 23.3365 25.4187 23.7981C24.9754 24.2597 24.7264 24.8858 24.7264 25.5387C24.7264 26.1915 24.9754 26.8176 25.4187 27.2793C25.8619 27.7409 26.4631 28.0002 27.09 28.0002V28.0002Z",
    stroke: "#E87A46",
    strokeWidth: 1.6,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6955 25.5385H23.5455V12.7385C23.5455 12.5426 23.4707 12.3548 23.3378 12.2163C23.2048 12.0778 23.0244 12 22.8364 12H7M12.4955 25.5385H10.0727C9.97961 25.5385 9.8874 25.5194 9.80137 25.4823C9.71534 25.4451 9.63717 25.3907 9.57132 25.3222C9.50548 25.2536 9.45325 25.1722 9.41761 25.0826C9.38198 24.993 9.36364 24.897 9.36364 24.8V18.7692",
    stroke: "#E87A46",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18359 15.6924H12.9109",
    stroke: "#E87A46",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5449 15.6924H30.1749C30.312 15.6924 30.4461 15.7338 30.561 15.8116C30.676 15.8893 30.7668 16.0001 30.8226 16.1305L32.938 21.0881C32.9783 21.1822 32.9992 21.2841 32.9995 21.3872V24.8001C32.9995 24.8971 32.9811 24.9931 32.9455 25.0827C32.9099 25.1723 32.8576 25.2537 32.7918 25.3222C32.7259 25.3908 32.6478 25.4452 32.5617 25.4823C32.4757 25.5194 32.3835 25.5385 32.2904 25.5385H30.0449M23.5449 25.5385H24.7267",
    stroke: "#E87A46",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#E87A46",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableCouriers);
export default __webpack_public_path__ + "static/media/AvailableCouriers.65810779a7aec72df6dc508a03e3a966.svg";
export { ForwardRef as ReactComponent };